// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"834":"5568c9a0","989":"fef51918"}[chunkId] + ".chunk.css";
};